import { getClient, type ConflictVersionError } from "foundation-client";

export async function getAutoBookmark(artId: number) {
  const client = getClient();
  const res = await client.GET("/api/users/me/arts/{art_id}/fb3/autobookmark", {
    params: {
      path: { art_id: artId },
    },
  });
  return { ...res, data: res.data?.payload?.data };
}

type PostBody = {
  id: string;
  created_at: string;
  percent: number;
  version: number;
  xpointer: string;
  chapter_title: string;
};

export async function postAutoBookmark(artId: number, params: PostBody) {
  const client = getClient();
  const res = await client.POST(
    "/api/users/me/arts/{art_id}/fb3/autobookmark",
    {
      params: {
        path: { art_id: artId },
      },
      body: { ...params, is_epub: false, device_name: "web" },
    }
  );
  return {
    ...res,
    data: res.data?.payload?.data,
    status: res.response?.status,
    // Версия с сервера при 409 конфликте
    conflictVersion: (res.error as ConflictVersionError)?.payload?.data
      ?.version,
  };
}

export async function getBookmarks(artId: number) {
  const client = getClient();
  const res = await client.GET("/api/users/me/arts/{art_id}/fb3/bookmarks", {
    params: {
      path: { art_id: artId },
    },
  });
  if (res.response?.status === 403) {
    throw new Error("Forbidden");
  }
  return res.data?.payload?.data;
}

export async function postBookmark(artId: number, params: PostBody) {
  const client = getClient();
  const res = await client.POST("/api/users/me/arts/{art_id}/fb3/bookmarks", {
    params: { path: { art_id: artId } },
    body: { ...params, is_epub: false },
  });
  return res;
}

export async function deleteBookmark(artId: number, bookmarkId: string) {
  const client = getClient();
  const res = await client.DELETE(
    "/api/users/me/arts/{art_id}/fb3/bookmarks/{bookmark_id}",
    {
      params: {
        path: { art_id: artId, bookmark_id: bookmarkId },
      },
    }
  );
  return res;
}

export type Bookmark = Awaited<ReturnType<typeof getBookmarks>>[number];
export type AutoBookmark = Awaited<ReturnType<typeof getAutoBookmark>>;
